import { Link, useNavigate } from "react-router-dom";
import ChevronDown from "@assets/svg/ChevronDown";
import PlusIcon from "@assets/svg/PlusIcon";
import SearchIcon from "@assets/svg/SearchIcon";
import { getCompanyList } from "@endpoints/company.service";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCompanies } from "@store/actions/company.action";

const ItemCard = ({ data, index }) => {
  return (
    <Link
      to={`/contacts/edit-company/${data?._id}`}
      className={`items-center justify-between py-3 hover:bg-gray-50 cursor-pointer grid grid-cols-[1fr_1fr_0.7fr_0.4fr] ${
        index !== 0 ? "border-t" : ""
      }`}
    >
      <div className="flex items-center gap-3 pl-5">
        <div className="h-4 w-4 border rounded-sm" />
        <label className="flex font-medium text-xs text-charcoal cursor-pointer">
          {data?.refNo}
        </label>
      </div>
      <label className="flex font-medium text-xs text-charcoal cursor-pointer">
        {data?.name}
      </label>
      <label className="flex font-medium text-xs text-charcoal cursor-pointer">
        {data?.phoneNumber ?? "-"}
      </label>
      <span className="font-medium text-xs text-secondary">Manual</span>
    </Link>
  );
};

const CompaniesSection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { companies } = useSelector((state) => state?.company);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCompanyList("?page=1&limit=10")
      .then((response) => {
        const { data, success } = response;
        if (success) {
          dispatch(setCompanies(data));
        }
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="gap-2.5 flex mt-16 flex-col">
        {Array.from({ length: 10 }, (x, i) => i).map((key) => {
          return (
            <div className="flex justify-between">
              <div
                style={{
                  borderWidth: 1,
                }}
                className="flex rounded-lg w-full pl-3 pr-8 py-4 gap-1.5"
              >
                <div className="h-3 rounded bg-gray-200 w-1/4"></div>
                <div className="h-3 rounded bg-gray-200 w-1/4"></div>
                <div className="h-3 rounded bg-gray-200 w-1/4"></div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  if (companies?.length === 0) {
    return (
      <div className="flex flex-1 h-screen flex-col items-center justify-center">
        <p className="text-charcoal font-semibold">No companies created</p>
        <p className="mt-7 mb-2">Create a company now!</p>
        <button
          onClick={() => navigate("/contacts/add-company")}
          className="flex items-center justify-center border bg-green-600 rounded-md px-2 py-1 gap-1 text-white font-semibold text-sm"
        >
          <PlusIcon className={"w-4 h-4"} fill={"white"} />
          Company
        </button>
      </div>
    );
  }

  return (
    <>
      {/* Search and filter section */}
      <div className="flex items-center justify-between bg-[#F1F5F9] p-1 rounded-md my-4">
        <div className="flex items-center h-full gap-3">
          {/* Input container */}
          <div className="bg-white rounded-md px-3 border flex items-center h-8">
            <input
              className="text-xs font-medium flex-1 outline-none h-full w-64"
              placeholder="Search by Name, Title or Ref number..."
            />
            <SearchIcon className="w-4 h-4" color="gray" />
          </div>
          <button className="flex items-center justify-center border bg-white rounded-md px-3 h-full gap-4">
            <label className="text-charcoal text-xs font-medium">
              Filter status
            </label>
            <ChevronDown className={"w-4 h-4"} fill={"#2e2e2e"} />
          </button>
        </div>
        <button
          onClick={() => navigate("/contacts/add-company")}
          className="flex items-center justify-center border bg-primary rounded-md px-2 py-1 gap-1 text-white font-semibold text-sm"
        >
          <PlusIcon className={"w-4 h-4"} fill={"white"} />
          Company
        </button>
      </div>

      {/* ScrollArea  */}
      <div className="grid grid-cols-[1fr_1fr_0.7fr_0.4fr] border-b pb-3">
        <label className="font-semibold text-charcoal text-xs pl-5">
          Reference No.
        </label>
        <label className="font-semibold text-charcoal text-xs">
          Company Name
        </label>
        <label className="font-semibold text-charcoal text-xs">
          Primary Contact
        </label>
      </div>
      <div className="flex flex-col max-h-fit overflow-y-scroll no-scrollbar">
        {companies?.map((item, index) => {
          return <ItemCard key={item?._id} data={item} index={index} />;
        })}
      </div>
    </>
  );
};

export default CompaniesSection;
